export default {
    header: {
        telefone: "هاتف",
        signIn: "تسجيل الدخول",
        register: "تسجيل",
        becomeExpert: "سجل شركتك",
        dashboard: "لوحة التحكم",

        sidebar: {
            tuktuk: {
                title: "توك توك",
                subtitle: "حجز توك توك",
                menu: {
                    grid: "قائمة توك توك",
                },
            },
            about: {
                title: "حول",
                subtitle: "حول",
                menu: {
                    aboutUs: "من نحن",
                    testimonials: "شهادات",
                    faq: "الأسئلة الشائعة",
                    contact: "اتصل بنا",
                    terms: "الشروط والأحكام",
                    privacy: "سياسة الخصوصية",
                },
            },
            dashboard: {
                title: "لوحة التحكم",
                subtitle: "لوحة تحكم المستخدم",
                subtitle2: "لوحة تحكم الوكيل",
                menu: {
                    dashboard: "لوحة التحكم",
                    myBookings: "حجوزاتي",
                    reviews: "المراجعات",
                    support: "الدعم",
                    wishlist: "قائمة الرغبات",
                    wallet: "المحفظة",
                    profileSettings: "إعدادات الملف الشخصي",
                    notifications: "الإشعارات",
                    myProfile: "ملفي الشخصي",
                    settings: "الإعدادات",
                    dashboard2: "لوحة التحكم",
                    bookings: "الحجوزات",
                    enquiries: "الاستفسارات",
                    earnings: "الأرباح",
                    reviews2: "المراجعات",
                    settings2: "الإعدادات",
                },
            },
            social: {
                title: "شبكة اجتماعية",
                subtitle: "موجز المشاركات",
                menu: {
                    feed: "الموجز",
                    myProfilePage: "صفحتي الشخصية",
                    explore: "استكشف",
                },
            },
        },
    },

    common: {
        welcome: "مرحباً، {{name}}!",
    },

    home: {
        hero: {
            title: "اقترب من الحلم:",
            title2: "أساسيات رحلتك في انتظارك",
            title3: "أنت",
            subtitle: "وجهتك النهائية لكل ما يساعد على الاحتفال وتذكر تجربة سفرك.",
            tukTuk: "توك توك",
        },
        searchBy: {
            titlePrefix: "باقات",
            titleSuffix: "حديثة",
            subtitle:
                "اكتشف أحدث الباقات المضافة إلى Portugalwaytour واستكشف فرص السفر الفريدة المختارة بعناية لتوفر لك تجارب لا تُنسى ووجهات جديدة ومغامرات حصرية حول العالم.",
            noPackages: "لم يتم العثور على باقات حديثة.",
            hasDiferencial: "يوجد فرق",
            noReviews: "لا توجد تقييمات",
            viewAll: "عرض جميع الباقات",
        },
        sectionBenefit: {
            titlePrefix: "لدينا",
            titleHighlight: "الفوائد",
            titleSuffix: "والمزايا الرئيسية",
            subtitle:
                "تقدم Portugalway، وهي شركة سياحة متخصصة في وجهات الأحلام، مجموعة متنوعة من الفوائد للمسافرين.",
            benefits: [
                {
                    title: "تجارب أصيلة",
                    description:
                        "اهرب من السياحة التقليدية واكتشف البرتغال الأصيلة! جولاتنا تقدم تجارب حقيقية لاستكشاف الثقافة المحلية والمأكولات والأماكن السرية.",
                },
                {
                    title: "باقات سفر مخصصة",
                    description:
                        "اصنع رحلتك المخصصة! اختر تجربتك ونحن نهتم بكل شيء: الإقامة، النقل، والأنشطة، لرحلة شخصية لا تُنسى.",
                },
                {
                    title: "الراحة والأمان",
                    description:
                        "نحن نهتم بجميع التفاصيل: وسائل نقل مريحة، إقامة مختارة، ومرافقة مرشدين محترفين، مما يضمن راحة البال من بداية الرحلة حتى نهايتها.",
                },
                {
                    title: "خدمة مخصصة",
                    description:
                        "من الاتصال الأول حتى عودتك من الرحلة، تحصل على دعم شخصي وفريق مستعد لخدمتك باللغتين البرتغالية والإنجليزية، بسرعة واهتمام كامل باحتياجاتك.",
                },
            ],
        },
        exploreCities: {
            title: "استكشف حسب المدينة",
            subtitle: "اكتشف تجارب فريدة في وجهات رائعة",
        },
        placeSection: {
            titlePrefix: "باقات",
            titleHighlight: "رائجة",
            subtitle:
                "استكشف باقات سفرنا الأكثر شعبية، المختارة بعناية بناءً على تقييماتها العالية، والمراجعات الإيجابية، والحجوزات المتكررة من المسافرين الآخرين. اعثر على مغامرتك القادمة التي لا تُنسى هنا.",
            all: "الكل",
            hasDiferencial: "يوجد فرق",
            noReviews: "لا توجد تقييمات",
            viewAll: "عرض جميع الباقات",
        },
        aboutSection: {
            welcome: "مرحباً بكم في Portugalwaytour",
            title: "استكشف ما وراء الأفق: اكتشف عجائب العالم",
            description1: "في Portugal Way Tour، نؤمن بأن السفر تحول. نحن وكالة متخصصة في التجارب السياحية الفريدة في البرتغال، ملتزمون بكشف أفضل ما في البلاد - ثقافتها ومناظرها الطبيعية وتاريخها وأصالتها.",
            point1: "توفير رحلات لا تُنسى، مع الراحة والأمان والسحر. نريد أن يكتشف كل سائح البرتغال بعمق، من خلال مسارات تجمع بين التقاليد والطبيعة والمأكولات والضيافة الأصيلة.",
            point2: "أن نكون مرجعاً للجودة والثقة في السياحة في البرتغال، معترفاً بها من قبل السياح من جميع أنحاء العالم كمرادف للاحتراف والسحر.",
            learnMore: "تعلم المزيد",
            reviews: "{{count}}+ تقييمات"
        },
        aboutCounters: [
            { label: "وجهات حول العالم", icon: "isax-global5", colorClass: "text-teal" },
            { label: "حجوزات مكتملة", icon: "isax-calendar-2", colorClass: "text-purple" },
            { label: "عملاء عالميون", icon: "isax-tag-user5", colorClass: "text-pink" },
            { label: "موردون مسجلون", icon: "isax-status-up5", colorClass: "text-info" },
        ],
        expertSection: {
            popularTitle: "شعبية",
            popularSubtitle: "اكتشف الخدمات الأكثر شعبية، ذات التقييمات العالية، والمحجوزة بشكل متكرر من قبل المسافرين.",
            serviceName: "سائق توك توك",
            loading: "جار التحميل...",
            reservationsSingular: "حجز",
            reservationsPlural: "حجوزات",
            viewProfile: "عرض الملف الشخصي",
            viewAll: "عرض الكل",
        },
        driverModal: {
            loading: "جار التحميل...",
            description: "الوصف",
            languages: "اللغات",
            vehicle: "المركبة",
            seats: "مقاعد",
            averageRating: "متوسط التقييم",
            reviews: "المراجعات",
            packages: "الباقات",
            noReviews: "لا توجد تقييمات بعد",
            noPackages: "هذا السائق لا يملك باقات مسجلة"
        },
        testimonialSection: {
            title: "ماذا يقول مستخدمونا",
            highlight: "المستخدمون",
            subtitle: "اطلع على ما قاله مسافرونا عن تجاربهم.",
            loading: "جار تحميل التقييمات...",
            noReviews: "لم يتم العثور على تقييمات.",
            noComment: "لم يترك المستخدم تعليقاً.",
            viewPackage: "عرض تفاصيل الباقة"
        },
        updateSection: {
            faq: {
                title: "الأسئلة المتكررة",
                highlight: "المتكررة",
                subtitle: "تقدم Portugalway، وهي شركة سياحة متخصصة في وجهات الأحلام، مجموعة متنوعة من الفوائد للمسافرين.",
                questions: [
                    {
                        question: "كيف أحجز جولة؟",
                        answer: "يمكنك الحجز مباشرة عبر موقعنا الإلكتروني أو الاتصال بنا عبر البريد الإلكتروني أو الهاتف. بعد تحديد المسار المطلوب، نقدم عرض أسعار، نؤكد الفنادق والخدمات، ونطلب الدفع وفقاً للسياسة المعلنة."
                    },
                    {
                        question: "هل يمكن تخصيص المسار؟",
                        answer: "نعم! جميع مساراتنا مرنة. يمكنك اختيار الأماكن التي ترغب في زيارتها، ومدة الإقامة، ونوع الإقامة، وفي حدود الإمكانيات، نصنع شيئًا يناسب ملفك الشخصي."
                    },
                    {
                        question: "ما هي لغات المرشدين؟",
                        answer: "لدينا مرشدون يتحدثون البرتغالية والإنجليزية، ووفقًا للجولة، لغات أخرى. يرجى إبلاغنا بتفضيلاتك عند الحجز حتى نتمكن من تخصيص المرشد الأنسب."
                    },
                    {
                        question: "ما هي سياسة الإلغاء؟",
                        answer: "لدينا سياسة إلغاء تختلف حسب الجولة، والمدة المسبقة، والموردين. عند الحجز، نرسل الشروط الكاملة. نرجو القراءة بعناية قبل التأكيد."
                    },
                    {
                        question: "ما هي طرق الدفع المقبولة؟",
                        answer: "نقبل التحويل البنكي الدولي، وبطاقة الائتمان، وفي بعض الحالات، طرق دفع أخرى."
                    }
                ],
                contactUsText: "إذا لم تجد إجابة لسؤالك في الأسئلة الشائعة، يرجى الاتصال بنا. سنجيب قريباً!",
                contactButton: "اتصل بنا",
            },
            support: {
                items: [
                    "مسارات مخصصة",
                    "تخطيط كامل",
                    "توجيه الخبراء",
                    "تجربة محلية",
                    "دعم العملاء",
                    "جهود الاستدامة",
                    "مناطق متعددة"
                ]
            }
        }
    },
    footer: {
        pages: {
            title: "صفحات",
            settings: "الإعدادات",
            profile: "الملف الشخصي",
            social: "شبكة اجتماعية",
        },
        company: {
            title: "الشركة",
            about: "من نحن",
            testimonials: "شهادات",
            faq: "الأسئلة الشائعة",
        },
        support: {
            title: "الدعم",
            contact: "اتصل بنا",
            privacy: "سياسة الخصوصية",
            terms: "الشروط والأحكام",
            chat: "دعم الدردشة",
        },
        services: {
            title: "الخدمات",
            tuktuk: "توك توك",
            winery: "مصنع نبيذ",
            restaurant: "مطعم",
            car: "سيارة",
            hippotrip: "رحلة هيپو",
            bike: "دراجة",
        },
        bottom: {
            copyright: "حقوق الطبع والنشر © 2025. جميع الحقوق محفوظة،",
            brand: "Portugalwaytour",
            social: [
                { icon: "fa-brands fa-facebook", link: "#" },
                { icon: "fa-brands fa-x-twitter", link: "#" },
                { icon: "fa-brands fa-instagram", link: "#" },
                { icon: "fa-brands fa-linkedin", link: "#" },
                { icon: "fa-brands fa-pinterest", link: "#" },
            ],
            cards: [
                "assets/img/icons/card-01.svg",
                "assets/img/icons/card-02.svg",
                "assets/img/icons/card-03.svg",
                "assets/img/icons/card-04.svg",
                "assets/img/icons/card-05.svg",
                "assets/img/icons/card-06.svg",
            ],
        },
    },

    auth: {
        registerModal: {
            title: "الوصول إلى حسابك",
            subtitle: "أدخل بريدك الإلكتروني لتسجيل الدخول أو إنشاء حساب",
            emailLabel: "البريد الإلكتروني",
            emailPlaceholder: "أدخل بريدك الإلكتروني",
            sendTestCode: "إرسال رمز الاختبار",
            sendEmailCode: "إرسال الرمز عبر البريد الإلكتروني",
            codeLabel: "رمز التحقق",
            codePlaceholder: "أدخل الرمز",
            verifyAndLogin: "تحقق وتسجيل الدخول",
            testCodeSuccess: "تم إنشاء رمز الاختبار '123456'. استخدمه لتسجيل الدخول.",
            testCodeError: "خطأ في إنشاء رمز الاختبار.",
            emailSent: "تم إرسال الرمز إلى بريدك الإلكتروني!",
            emailError: "خطأ في إرسال الرمز عبر البريد الإلكتروني.",
            loginSuccess: "تم تسجيل الدخول بنجاح!",
            invalidCode: "رمز غير صالح أو منتهي الصلاحية.",
            or: "أو",
            google: "جوجل",
            facebook: "فيسبوك",
            reminderTitle: "أكمل ملفك الشخصي",
            reminderText: "لا تنس إكمال ملفك الشخصي للاستمتاع بجميع ميزات المنصة!",
            gotIt: "فهمت",
        },
    },
    companyRegisterModal: {
        title: "تسجيل الشركة",
        step1: "الرجاء إدخال بريدك الإلكتروني الشخصي لإنشاء حساب مسؤول الشركة. ستستخدم هذا الحساب لإدارة ملف تعريف الشركة.",
        step2: "أرسلنا رمز تحقق إلى بريدك الإلكتروني. أدخله أدناه للتحقق من هويتك.",
        step3: "الآن املأ بيانات شركتك. يجب أن يكون البريد الإلكتروني للشركة اتصالاً تجارياً (على سبيل المثال: info@empresa.com).",

        personalEmail: "بريدك الإلكتروني الشخصي",
        sendTestCode: "إرسال رمز الاختبار",
        sendEmailCode: "إرسال الرمز عبر البريد الإلكتروني",

        verificationCode: "رمز التحقق",
        verifyCode: "تحقق من الرمز",

        companyEmail: "البريد الإلكتروني للشركة",
        companyName: "اسم الشركة",
        nif: "NIF",
        nib: "NIB",
        permanentCertificate: "رقم الشهادة الدائمة",
        phone: "الهاتف",
        street: "الشارع",
        city: "المدينة",
        postalCode: "الرمز البريدي",
        country: "البلد",
        companyDescription: "وصف موجز للشركة",
        servicesProvided: "الخدمات المقدمة",

        contractTitle: "عقد الشركة",
        acceptContract: "أقبل عقد الشركة",
        finishRegistration: "إنهاء التسجيل",

        messages: {
            "Test code sent successfully. Use '123456'.": "تم إرسال رمز الاختبار بنجاح. استخدم '123456'.",
            "Verification email sent successfully.": "تم إرسال رمز التحقق عبر البريد الإلكتروني بنجاح.",
            "Verification successful.": "تم التحقق بنجاح.",
            "Company registered and contract accepted successfully!": "تم تسجيل الشركة وقبول العقد بنجاح!",
            testStepMessage: "تم إرسال رمز الاختبار بنجاح. استخدم '123456'.",
            emailStepMessage: "تم إرسال رمز تحقق إلى بريدك الإلكتروني. أدخله أدناه."
        },

        errors: {
            "Failed to send the verification code.": "فشل في إرسال رمز التحقق.",
            "Invalid or expired code.": "رمز غير صالح أو منتهي الصلاحية.",
            "Please fill all required fields.": "الرجاء ملء جميع الحقول المطلوبة.",
            "You must accept the contract to register the company.": "يجب عليك قبول العقد لتسجيل الشركة.",
            "You must be logged in to register the company.": "يجب أن تكون مسجلاً للدخول لتسجيل الشركة.",
            "Failed to register the company or accept the contract.": "فشل في تسجيل الشركة أو قبول العقد."
        }
    },
    chooseUsSection: {
        title: "لماذا تختارنا؟",
        cards: [
            {
                title: "الراحة",
                description: "خطط لرحلتك بأكملها من منصة واحدة، مما يوفر الوقت والجهد. لا مزيد من التبديل بين المواقع المختلفة."
            },
            {
                title: "ضمان أفضل سعر",
                description: "نحن نعمل مع شركاء سفر موثوق بهم لنقدم لك أفضل العروض، سواء كنت تحجز رحلة طيران، فندقًا، أو استئجار سيارة."
            },
            {
                title: "دعم العملاء",
                description: "فريق الدعم المخصص لدينا متاح لك على مدار 24 ساعة طوال أيام الأسبوع، مما يضمن سير خطط سفرك بسلاسة من البداية إلى النهاية."
            },
            {
                title: "تجارب سفر مخصصة",
                description: "سواء كنت تسافر للعمل، عطلة عائلية، أو مغامرة فردية، نقدم خيارات تلبي جميع الاحتياجات."
            }
        ]
    },

    contactUsSection: {
        breadcrumb: {
            home: "الرئيسية",
            pages: "صفحات",
            contactUs: "اتصل بنا"
        },
        title: "تواصل مع فريق الدعم المخصص لدينا",
        description: "فريقنا مستعد للمساعدة. رضاك هو أولويتنا.",
        info: [
            {
                label: "عنوان البريد الإلكتروني",
                value: "portugaltourway@gmail.com"
            },
            {
                label: "رقم الهاتف",
                value: "أدخل الرقم"
            },
            {
                label: "موقعنا",
                value: "أدخل الشارع، المادا - البرتغال"
            }
        ],
        supportCard: {
            title: "هل تحتاج إلى دعم؟",
            textLoggedOut: "للتواصل مع فريق الدعم لدينا وفتح التذاكر، يجب عليك إنشاء حساب أو تسجيل الدخول. بعد ذلك، ستتمكن من الوصول الكامل إلى لوحة دعمك، حيث يمكنك تتبع طلباتك وإدارتها.",
            textLoggedIn: "أنت مسجل الدخول بالفعل! يمكنك الآن فتح تذكرة دعم جديدة أو تتبع التذاكر الموجودة مباشرة من لوحة التحكم الخاصة بك.",
            btnLoggedOut: "إنشاء حساب / تسجيل الدخول",
            btnLoggedIn: "فتح تذكرة في لوحة التحكم"
        }
    },

    sidebar: {
        main: "الرئيسية",
        dashboard: "لوحة التحكم",
        myBookings: "حجوزاتي",
        myReviews: "المراجعات",
        wishlist: "قائمة الرغبات",
        support: "الدعم",
        finance: "المالية",
        wallet: "المحفظة",
        payments: "المدفوعات",
        account: "الحساب",
        myProfile: "ملفي الشخصي",
        notifications: "الإشعارات",
        settings: "الإعدادات",
        preferences: "التفضيلات",
        logout: "تسجيل الخروج",
    },

    agentSidebar: {
        dashboard: "لوحة التحكم",
        bookings: "الحجوزات",
        tukTukBookings: "حجوزات التوك توك",
        hotelBookings: "حجوزات الفنادق",
        carBookings: "حجوزات السيارات",
        cruiseBookings: "حجوزات الرحلات البحرية",
        tourBookings: "حجوزات الجولات",
        flightBookings: "حجوزات الطيران",
        enquiries: "الاستفسارات",
        earnings: "الأرباح",
        reviews: "المراجعات",
        support: "الدعم",
        serviceEnrollment: "تسجيل الخدمات",
        drivers: "السائقين",
        tukTukVehicles: "مركبات التوك توك",
        settings: "الإعدادات",
        logout: "تسجيل الخروج",
    },

    dashboardCards: {
        totalBookings: "إجمالي الباقات المشتراة",
        totalListings: "إجمالي الباقات",
        totalEarnings: "إجمالي الأرباح",
        totalReviews: "إجمالي التقييمات",
    },

    recentlyadded: {
        titulo: "أضيفت حديثًا",
    },

    BookingsStatistics: {
        titulo: "إحصائيات الحجوزات",
        loading: "جار تحميل الإحصائيات...",
        none: "لم يتم تسجيل أي حجوزات بعد.",
    }
};